// extracted by mini-css-extract-plugin
export default {"wrapper":"Snackbar_wrapper__neOpJ","snackbar":"Snackbar_snackbar__NURdk","success":"Snackbar_success__6L+iG","error":"Snackbar_error__lj9UL"};